import React from 'react'

const RelationshipsContext = React.createContext({})

export default RelationshipsContext
